import { useTranslations } from '@vocab/react';
import { Text, Box, TextLinkButton, Alert } from 'braid-design-system';

import translations from './.vocab';

const pageReload = () => location.reload();

const UnhandledErrorPageBlock = () => {
  const { t } = useTranslations(translations);
  return (
    <Box data-cy="global-error">
      <Alert tone="critical">
        <Text>
          {t('Error loading this page', {
            button: (children) => (
              <TextLinkButton key="error-alert" onClick={pageReload}>
                {children}
              </TextLinkButton>
            ),
          })}
        </Text>
      </Alert>
    </Box>
  );
};

export default UnhandledErrorPageBlock;
